<template>
  <i class="icon" :class="'icon-'+type" :style="{height: sizeW + 'px', width: sizeH + 'px'}" @click="onClick"></i>
</template>

<script>
  export default {
    name: 'Icon',
    props: {
      type: {
        type: String,
        default: '',
      },
      sizeW: {
        type: Number,
        default: 15,
      },
       sizeH: {
        type: Number,
        default: 15,
      },
    },
    methods: {
      onClick() {
        this.$emit('click')
      }
    },

  };
</script>



// WEBPACK FOOTER //
// src/components/Icon.vue